/*
 * @Descripttion:
 * @Author: zhangtingjiang
 * @Date: 2019-11-07 13:08:17
 */
// 是否添加
function isPushRouter (routes, router) {
  let shouldAdd = true
  routes.forEach(value => {
    if (value.path === router.path) {
      shouldAdd = false
    }
  })
  return shouldAdd
}
// 替换、截取、添加
function controllerRouter (routes, router) {
  let currentLevel = router.meta.level
  let routerLevel = routes[routes.length - 1].meta.level
  if (currentLevel > routerLevel) {
    routes.push(router)
  } else if (currentLevel === routerLevel) {
    let index = routes.length - 1
    routes.splice(index)
    routes.push(router)
  } else {
    let matchIndex = 1
    routes.forEach((val, key) => {
      if (val.meta.level === router.meta.level) {
        matchIndex = key
      }
    })
    routes.splice(matchIndex)
    routes.push(router)
  }
}
export default {
  namespaced: true,
  state: {
    breadcrubs: []
  },
  mutations: {
    addBreadcrub (state, item) {
      let firstRouter = item.matched[0]
      if (state.breadcrubs.length > 0 && state.breadcrubs[0].path === firstRouter.path) {
        // 同一个项
        if (isPushRouter(state.breadcrubs, item)) {
          // meta里面的level 大于则添加 等于则替换 小于则截取
          controllerRouter(state.breadcrubs, item)
        } else {
          // breadcrubs里面已经存 删除item之后的
          let spliceIndex = 0
          state.breadcrubs.forEach((value, key) => {
            if (value.path === item.path) {
              spliceIndex = key + 1
            }
          })
          state.breadcrubs.splice(spliceIndex)
        }
      } else {
        // 不同项
        if (state.breadcrubs.length === 0 && localStorage.getItem('breadcrubs')) {
          let getAsyncRoutes = JSON.parse(localStorage.getItem('breadcrubs'))
          state.breadcrubs = getAsyncRoutes
        } else {
          state.breadcrubs = []
          state.breadcrubs.push(firstRouter)
          state.breadcrubs.push(item)
        }
      }
      // 添加活动的title
      let stateFirstRouter = state.breadcrubs[1]
      if (stateFirstRouter.path === '/matchList') {
        if (state.breadcrubs.length > 2) {
          let actTitle = sessionStorage.getItem('topNavActTitle')
          if (actTitle) {
            let actIndex = 0
            if (state.breadcrubs[2].path === 'activityDetail') {
              actIndex = 1
            }
            state.breadcrubs.splice(2, actIndex, {
              path: 'activityDetail',
              name: 'activityDetail',
              noredirect: true,
              meta: {
                title: actTitle
              }
            })
          }
        }
      }
      let storeRoutes = state.breadcrubs.map(route => {
        let obj = {
          path: route.path,
          name: route.name,
          meta: route.meta,
          query: route.query,
          params: route.params
        }
        return obj
      })

      localStorage.setItem('breadcrubs', JSON.stringify(storeRoutes))
    },
    moveBreadcrub (state, item) {
      let spliceIndex = 0
      state.breadcrubs.forEach((value, key) => {
        if (value.name === item.name) {
          spliceIndex = key
        }
      })
      state.breadcrubs.splice(spliceIndex)
    }
  },
  actions: {
    dispatchAddBreadcrub ({ commit }, item) {
      commit('addBreadcrub', item)
    },
    dispatchMoveBreadcrub ({ commit }, item) {
      commit('moveBreadcrub', item)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/breadcrub.js